export default __webpack_public_path__ + "static/media/ebrima.d27ba810.ttf";